import { RouteObject } from 'react-router-dom';

import { UserModel } from '@/models/UserModel';

import { getAddStaffRoutes } from './getAddStaffRoutes';
import { getAdminHubGeneralRoutes } from './getAdminHubGeneralRoutes';
import { getAdminHubStaffOverviewRoutes } from './getAdminHubStaffOverviewRoutes';
import { getDataCenterRoutes } from './getDataCenterRoutes';
import { getOrgWideSettingsRoutes } from './getOrgWideSettingsRoutes';
import { getStaffRoutes } from './getStaffRoutes';

export const getSharedRoutes = (currentUser: UserModel): RouteObject[] => {
  return [
    ...getAddStaffRoutes(),
    ...getAdminHubGeneralRoutes(),
    ...getAdminHubStaffOverviewRoutes(),
    ...getOrgWideSettingsRoutes(),
    ...getDataCenterRoutes(currentUser),
    ...getStaffRoutes()
  ];
};

// TODO: Create a generic catch-all route for shared/ehr/crm.
